import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Radio } from '@mui/material'

const RadioButton = ({ value, label, sx = {} }) => {
  return (
    <FormControlLabel
      value={value}
      control={<Radio />}
      labelPlacement="start"
      label={label}
      sx={{
        border: 1,
        borderRadius: '10px',
        borderColor: 'grey.300',
        pl: 1,
        ml: 0,
        ...sx,
      }}
    />
  )
}

RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

export default RadioButton
